function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 135.23,
  fill: "#F9DBED",
  width: 77.896,
  height: 84.77
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.457,
  y: 150.123,
  fill: "#92C5C9",
  width: 54.984,
  height: 54.984
}), /*#__PURE__*/React.createElement("rect", {
  x: 137.896,
  y: 135.23,
  fill: "#E76DB6",
  width: 32.074,
  height: 84.77
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#C8E2E4",
  points: "71.457,205.107 85.203,205.107 126.441,150.123 112.695,150.123  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#ADD4D7",
  points: "85.203,205.107 98.949,205.107 126.441,168.45 126.441,150.123  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#77B7BC",
  points: "98.949,205.107 112.695,205.107 126.441,186.778 126.441,168.45  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#929292",
  points: "125.152,134.058 173.316,134.058 195.191,0 147.027,0  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "177.639,220 169.723,220 251.438,110.332 255.459,115.72  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "251.438,220 173.623,115.72 177.639,110.332 259.557,220  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "208.93,220 200.896,220 282.725,110.332 286.744,115.72  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#3B3835",
  points: "282.725,220 204.902,115.72 208.93,110.332 290.963,220  "
})), /*#__PURE__*/React.createElement("rect", {
  x: 146.803,
  fill: "#FFFFFF",
  width: 118.025,
  height: 118.026
}), /*#__PURE__*/React.createElement("rect", {
  x: 264.828,
  fill: "#3B3835",
  width: 48.164,
  height: 118.026
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#CCCCCC",
  points: "334.867,134.058 286.701,134.058 264.828,0 312.992,0  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 158.648,
  y: 95.872,
  fill: "#929292",
  width: 93.66,
  height: 11.275
}), /*#__PURE__*/React.createElement("rect", {
  x: 204.902,
  y: 10.744,
  fill: "#929292",
  width: 47.406,
  height: 5.639
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#75383B",
  d: "M100,183.23c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2v-126c0-1.1,0.9-2,2-2h96c1.1,0,2,0.9,2,2V183.23z"
})), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 65.23,
  fill: "#FFFFFF",
  width: 86,
  height: 110
}), /*#__PURE__*/React.createElement("rect", {
  x: 33,
  y: 58.23,
  fill: "#929292",
  width: 34,
  height: 14
}), /*#__PURE__*/React.createElement("rect", {
  x: 37,
  y: 48.23,
  fill: "#929292",
  width: 26,
  height: 10
}), /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 83.23,
  fill: "#929292",
  width: 50,
  height: 6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M79,93.23c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S82.859,93.23,79,93.23z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "77.902,90.055 74.334,86.604 75.625,85.271 77.809,87.384 82.287,82.407 83.666,83.648  "
}))), /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 105.23,
  fill: "#929292",
  width: 50,
  height: 6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M79,115.23c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S82.859,115.23,79,115.23z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "77.902,112.055 74.334,108.604 75.625,107.271 77.809,109.385 82.287,104.408 83.666,105.648  "
}))), /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 127.23,
  fill: "#929292",
  width: 50,
  height: 6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M79,137.23c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S82.859,137.23,79,137.23z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "77.902,134.055 74.334,130.604 75.625,129.271 77.809,131.384 82.287,126.407 83.666,127.648  "
}))), /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 149.23,
  fill: "#929292",
  width: 50,
  height: 6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M79,159.23c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S82.859,159.23,79,159.23z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "77.902,156.055 74.334,152.604 75.625,151.271 77.809,153.384 82.287,148.407 83.666,149.648  "
})))));

var SvgQueEsObs06 = function SvgQueEsObs06(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "335px",
    height: "220px",
    viewBox: "0 0 335 220",
    enableBackground: "new 0 0 335 220",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs06, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_06.fed1067a.svg";
export { ForwardRef as ReactComponent };